import { ReactNode } from "react";
import Table from "../../../../Components/Table/Table";
import EmptyState from "Components/Common/EmptyState";
import EmptyLienWaiverIcon from "Assets/Img/EmptyLienWaiverIcon";
import Button from "Components/Common/Button/Button";

interface LienWaiverAction {
  label: string;
  variant: string;
}

export interface LienWaiverRow {
  id?: string;
  vendor?: string;
  amount: string;
  sent: string;
  status: string;
  statusClass: string;
  action?: LienWaiverAction;
  sending?: boolean;
}

interface LienWaiverTableProps {
  rows: LienWaiverRow[];
  onSubmit?: (row: LienWaiverRow) => void;
  showActions?: boolean;
}

export default function LienWaiverTable({
  rows,
  onSubmit,
  showActions = false,
}: LienWaiverTableProps) {
  const columns = [
    { header: "Vendor", accessor: "vendor" as const },
    {
      header: "Amount",
      render: (row: LienWaiverRow): ReactNode => (
        <div className="right">{row.amount}</div>
      ),
    },
    { header: "Sent", accessor: "sent" as const },
    {
      header: "Status",
      render: (row: LienWaiverRow): ReactNode => (
        <span className={row.statusClass}>{row.status}</span>
      ),
    },
    ...(showActions
      ? [
          {
            header: "Action",
            render: (row: LienWaiverRow): ReactNode =>
              row.action ? (
                <Button
                  className={`lwBtn ${row.action.variant}`.trim()}
                  onClick={() => onSubmit?.(row)}
                  disabled={row.sending}
                >
                  {row.sending ? "Sending..." : row.action.label}
                </Button>
              ) : (
                "—"
              ),
          },
        ]
      : []),
  ];

  return (
    <Table
      data={rows}
      columns={columns}
      fallbackUI={
        <EmptyState
          noBorder={true}
          height={"100px"}
          icon={<EmptyLienWaiverIcon />}
          title="No Lien Waivers Yet"
          subtitle="Lien waivers from contractors and subcontractors will appear here
      once they have been submitted for this draw."
        />
      }
    />
  );
}
